import { useQuery } from '@tanstack/react-query';

import { useSession } from '@/compositions/hooks/useSession';
import { notificationsKeys } from '@/services/notifications/notifications.keys';
import { NOTIFICATIONS_POLL_INTERVAL_MS } from '@/services/notifications/notifications.polling';
import { notificationsService } from '@/services/notifications/notifications.service';

/**
 * Quantos avisos pessoais ainda não foram lidos.
 *
 * Mora em `compositions/` porque quem consome é a `BottomNav`
 * (`components/layouts/`), e `components/` não pode importar de `modules/`
 * (docs/01) — o mesmo motivo pelo qual `useSession` está aqui.
 *
 * **Convidado não tem notificação**: sem sessão a consulta nem dispara e a
 * contagem é zero, então a barra não desenha badge para quem não tem conta.
 *
 * A atualização é o ping de `NOTIFICATIONS_POLL_INTERVAL_MS` — o racional do
 * intervalo está lá, num arquivo só, porque a lista usa o mesmo número.
 */
export function useUnreadNoticesCount(): number {
  const { session } = useSession();
  const profileId = session?.userId;

  const { data } = useQuery({
    queryKey: notificationsKeys.unreadCount(profileId ?? 'guest'),
    queryFn: () => notificationsService.countUnread(),
    enabled: Boolean(profileId),
    refetchInterval: NOTIFICATIONS_POLL_INTERVAL_MS,
    // O dado só é considerado velho quando o ping venceria de qualquer jeito:
    // sem isso, cada tela que remonta a barra dispararia uma consulta a mais
    // sem trazer informação nova.
    staleTime: NOTIFICATIONS_POLL_INTERVAL_MS,
  });

  return data ?? 0;
}
